import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectConfigExpressRegistrationPlace } from '../../store/slices/config/configSelectors'
import IconIndicator from '../user-feedback/IconIndicator'
import { Container } from 'rsuite'
import { initiateAdminUpdateFlow } from '../../store/slices/adminUpdate/adminUpdateThunks';
import { isNullUndefinedOrEmptyString } from '../../common/utils';
import { selectAdminUpdateInitiated, selectAdminUpdateToken } from '../../store/slices/adminUpdate/adminUpdateSelectors';
import { jwtDecode } from 'jwt-decode'
import usePlaceNavigate, { useInternalUrl } from '../../hooks/usePlaceNavigate'

const AdminRequireAuth = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const placeNavigate = usePlaceNavigate();

    const place = useSelector(selectConfigExpressRegistrationPlace);
    const token = useSelector(selectAdminUpdateToken);
    const flowInitiated = useSelector(selectAdminUpdateInitiated);

    const [loading, setLoading] = useState(true);

    const hasTokenAndFlowInitiated = useMemo(() => {
        return flowInitiated && !isNullUndefinedOrEmptyString(token);
    }, [token, flowInitiated]);

    const initUrl = useInternalUrl();

    useEffect(() => {
        const initiateFlow = async () => {
            setLoading(true);

            const queryParams = new URLSearchParams(location.search);
            const adminLoginToken = queryParams?.get('operatorLoginToken');

            // Initiate flow if it hasn't been initiated or if the token has changed
            if (!hasTokenAndFlowInitiated
                || (!isNullUndefinedOrEmptyString(adminLoginToken) && adminLoginToken !== token)
            ) {
                if (!isNullUndefinedOrEmptyString(adminLoginToken)) {
                    // check that the token is for the place the user is looking at
                    const decodedToken = jwtDecode(adminLoginToken);
                    if (decodedToken?.["com.deckard.jwt"].place === place) {
                        const successfull = await dispatch(initiateAdminUpdateFlow(adminLoginToken));

                        if (successfull) {
                            // navigate to the first step of the admin update flow
                            // Note we no longer need to pass the token in the query string becuase it has been saved in redux
                            placeNavigate('/admin-update-property');
                        }
                    }
                }
            }
            setLoading(false);
        };

        initiateFlow();
    }, [location.pathname, location.search, dispatch, hasTokenAndFlowInitiated]);

    if (loading) {
        return (
            <Container
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    width: '100vw',
                    margin: 0,
                    padding: 0
                }}
            >
                <IconIndicator />
            </Container>
        )
    }

    return hasTokenAndFlowInitiated ? (
        <Outlet />
    ) : (
        <Navigate to={initUrl} replace />
    )
}

export default AdminRequireAuth
